module.exports = __webpack_public_path__ + "static/media/tzzj.d9eae2d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/tzzj.png
// module id = 686
// module chunks = 0 1